import { createContext } from 'react';
import OrderHistoryFilterContextType from '../interfaces/context/OrderHistoryContextType';

export const OrderHistoryFilterContext = createContext<OrderHistoryFilterContextType | undefined>(undefined);
